import { Trans } from '@lingui/macro';
import { Info } from "lucide-react";
import { useState } from "react";
import { UtilApp } from "../../../services/Utils/UtilApp";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";

export const BotSourceTextModal: React.FC<{ text: string | undefined }> = ({ text }) => {
  const [show, setShow] = useState(false);
  const [sources, setSources] = useState("");

  function onOpen() {
    let sourceText = text?.replace('\n', '<br/>') ?? '';
    if (sourceText?.includes('Sources:')) {
      sourceText = sourceText?.split('Sources:')[1];
    }
    setSources(UtilApp.sanitizedHTML(sourceText));
    setShow(true);
  }

  return (
    <Dialog open={show} onOpenChange={setShow}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-4 w-4 text-muted-foreground hover:text-[color:rgb(var(--text-body))]" onClick={onOpen}>
          <Info className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle><Trans>Prompt information</Trans></DialogTitle>
        </DialogHeader>
        <div className="p-4 bg-muted/50 rounded-md text-sm text-[color:rgb(var(--text-body))] max-h-[60vh] overflow-y-auto">
          <div dangerouslySetInnerHTML={{ __html: sources }} />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default BotSourceTextModal;
